module.exports = __webpack_public_path__ + "static/img/hb_29-min.427790b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_29-min.png
// module id = StJ4
// module chunks = 1